import Vue from 'vue'
import Router from 'vue-router'
import Login from '../page/Login'
import MenuUtils from '../utils/MenuUtils.js'
import errorPage from '../page/errorPage.vue'
import WriteHandling from '../page/WriteHandling.vue'
import discuss from '../page/discuss.vue'
import ClassicCase from "../page/ClassicCase.vue"
import Video from "../page/Video.vue"
import File from "../page/File.vue"
import $api from '../http/api.js';

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

let publicRouter=[
	{
		path:'/login',
		name:'登录',
		component:Login
	},
	{
		name:"errorPage",
		path:'/404',
		component:errorPage
	},
	{
		name:"ClassicCase",
		path:'/ClassicCase',
		component:ClassicCase
	},
	{
		name:"Video",
		path:'/Video',
		component:Video
	},
	{
		name:"File",
		path:'/File',
		component:File
	}
]

let mainRouter=[
	
]

const router = new Router({
	isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
	routes: publicRouter
})

let menuItem=[]
function fnAddDynamicMenuRoutes(menuList=[],router=[]){
	menuItem=[]
	for(let i in menuList){
		let menu={
			path: null,
			component: null,
			name: menuList[i].name,
			parentId:menuList[i].parentId,
			menuId: menuList[i].menuId,
			meta: {
				menuId: menuList[i].menuId,
				title: menuList[i].name,
				isDynamic: true,
				isTab: true,
				parentId:menuList[i].parentId,
				icon:menuList[i].icon
			}
		}
		if(menuList[i].url){
			menu.path='/'+menuList[i].url
			menu.meta.path='/'+menuList[i].url
			menu.component=menuList[i].url
			menu.redirect= '/'+menuList[i].url+'/'+menuList[i].list[0].url
			menuItem.push(menu)
		}
		for(let j in menuList[i].list){
			let l={
				path: null,
				component: null,
				name: menuList[i].list[j].name,
				parentId:menuList[i].list[j].parentId,
				menuId: menuList[i].list[j].menuId,
				meta: {
					menuId: menuList[i].list[j].menuId,
					title: menuList[i].list[j].name,
					isDynamic: true,
					isTab: true,
					parentId:menuList[i].list[j].parentId,
					icon:menuList[i].list[j].icon
				}
			}
			if(menuList[i].list[j].url){
				l.path=menuList[i].list[j].url
				l.meta.path=menuList[i].list[j]
				l.component=menuList[i].list[j].url
				menuItem.push(l)
			}
		}
	}
}
function treeData(data) {
	data.forEach(function (item) {
		delete item.children;
	});
	var map = {};
	data.forEach(function (item) {
		map[item.menuId] = item;
	});
	var val = [];
	data.forEach(function (item) {
		var parent = map[item.parentId];
		if (parent) {
			(parent.children || ( parent.children = [] )).push(item);
		} else {
			val.push(item);
		}
	});
	return val;
}


router.beforeEach((to,from,next) => {
	let token = sessionStorage.getItem('token')
	if(to.path=='/login'){
		if(token){
			next({path:'/remoteImageCenter/ImageCenter'})
		}else{
			next()
		}
	}else{
		if(!token){
			next({path:'/login'})
		}else{
			if(!router.options.isAddDynamicMenuRoutes||to.matched.length==0||!window.sessionStorage.getItem('menuList')){
				let data={
					t:new Date().getTime()
				}
				$api.menu.getMenuList(data).then((res)=>{
					if (res && res.code === 0) {
						fnAddDynamicMenuRoutes(res.menuList)
						let menu=MenuUtils([],menuItem)
						mainRouter = treeData(menu)
						router.addRoutes(mainRouter.concat([
							{
								path: "/WriteHandling",
								name: "处理报告",
								component: WriteHandling
							},{
								path: "/discuss",
								name: "疑难讨论",
								component: discuss
							},{ 
								path: '*', 
								redirect: { path: '404' }
							}
						]))
						router.options.isAddDynamicMenuRoutes = true
						sessionStorage.setItem('menuList', JSON.stringify(menuItem || '[]'))
						sessionStorage.setItem('tree', JSON.stringify(mainRouter || '[]'))
						sessionStorage.setItem('permissions', JSON.stringify(res.permissions || '[]'))
						next({ ...to, replace: true })
					} else {
						sessionStorage.setItem('menuList', '[]')
						sessionStorage.setItem('permissions', '[]')
						next()
					}
				})
			}else{
				next()
			}
			
		}
	}
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js